
import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import GettingStartedSection from "@/components/faq/GettingStartedSection";
import ProtocolsSection from "@/components/faq/ProtocolsSection";
import TargetGenerationSection from "@/components/faq/TargetGenerationSection";
import TokensSection from "@/components/faq/TokensSection";
import TechnicalSection from "@/components/faq/TechnicalSection";
import SupportSection from "@/components/faq/SupportSection";

const FAQs: React.FC = () => {
  return (
    <PageLayout title="FAQs">
      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-4xl mb-8">FAQs</h1>
        
        <div className="prose prose-gray max-w-none">
          <div className="space-y-8">
            <GettingStartedSection />
            <ProtocolsSection />
            <TargetGenerationSection />
            <TokensSection />
            <TechnicalSection />
            <SupportSection />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default FAQs;
